import type { BaseExitRole } from '@einhaus/project314-types';

export interface StrategyCandidateAttachmentUpdate {
    strategyId: number;
    candidateIds: number[];
    defaultCandidateId: number;
    baseExitRole: BaseExitRole;
}

interface BuildStrategyCandidateAttachmentUpdateParams {
    hasPendingChanges: boolean;
    strategyId: number;
    selectedCandidateIds: number[];
    selectedDefaultCandidateId: number | null;
    persistedBaseCandidateId: number | null;
    selectedBaseExitRole: BaseExitRole | null;
}

export const buildStrategyCandidateAttachmentUpdate = ({
    hasPendingChanges,
    strategyId,
    selectedCandidateIds,
    selectedDefaultCandidateId,
    persistedBaseCandidateId,
    selectedBaseExitRole
}: BuildStrategyCandidateAttachmentUpdateParams): StrategyCandidateAttachmentUpdate | null => {
    if (!hasPendingChanges) return null;

    if (
        persistedBaseCandidateId === null ||
        selectedBaseExitRole === null ||
        selectedDefaultCandidateId === null ||
        !selectedCandidateIds.includes(persistedBaseCandidateId) ||
        !selectedCandidateIds.includes(selectedDefaultCandidateId)
    ) {
        throw new Error('Strategy exit candidates must retain the current base candidate and one attached default candidate.');
    }

    return {
        strategyId,
        candidateIds: selectedCandidateIds,
        defaultCandidateId: selectedDefaultCandidateId,
        baseExitRole: selectedBaseExitRole
    };
};
